import React from "react"
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import "bootstrap/dist/css/bootstrap.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { HiOutlineClipboardCopy } from 'react-icons/hi'
import ReactComment from './ReactComment'

import "./Output.scss"

function OutputTable ({title, table, report_type, className, precision, model}) {
  
  async function exportTableToClipboard(reportNode) {
    var csv = [];
    var rows = reportNode.querySelectorAll("tr");

    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++)
            row.push(cols[j].innerText);

    csv.push(row.join("\t"));
    }
    await setClipboard(csv.join("\n"));
  }


  async function setClipboard(text) {
    if (typeof window !== "undefined"){
      await navigator.clipboard.writeText(text).then(
        function () {}, 
        function(err) {
            console.error('Async: Could not copy text: ', err);
        }
      );
    }
  }

  

  return (
    <div className={className}>
      <div className="table-wrapper">
        {/* <OutputTabs data={tabs} /> */}
        <table id={className} className={precision ? 'table-content-export' : `table-content`}>
          <thead>
            <tr className="table-title">
              <Tippy placement="right" content="Copy output to clipboard"><p><HiOutlineClipboardCopy onClick={() => exportTableToClipboard(document.getElementById(`${className}`))} className="outputClipboard"/></p></Tippy>
              <tr className="title-content">
                <th className="title" data-bind={`text: reportNames()[${title}].rptName`}></th>
                {model === 'Charter' && [3,4].indexOf(title) > -1  ? <Tippy placement="right-start" content="For seafood industries, employment is measured in the total number of workers while for all other industries, it is measured in the total number of both full- and part-time jobs."><p><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy> : <p></p>}
              </tr>
            </tr>


            <tr>
              <th>Sector</th>
              <th><Tippy placement="bottom" content="At-Sea"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>AS</th>
              <th><Tippy placement="bottom" content="Aleutians West Census Area"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>AWCA</th>
              <th><Tippy placement="bottom" content="Aleutians East Borough"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>AEB</th>
              <th><Tippy placement="bottom" content="Lake and Peninsula Borough"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>LPB</th>
              <th><Tippy placement="bottom" content="Bristol Bay Borough"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>BBB</th>
              <th><Tippy placement="bottom" content="Dillingham Census Area"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>DCA</th>
              <th><Tippy placement="bottom" content="Kodiak Island Borough"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>KIB</th>
              <th><Tippy placement="bottom" content="Rest of Alaska"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>RAK</th>
              <th><Tippy placement="bottom" content="Washington, Oregon and California"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>WOC</th>
              <th><Tippy placement="bottom" content="Rest of the United States"><p className="regionToolTip"><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>RUS</th>
            </tr>
          </thead>
          <tbody data-bind={`foreach: {data: reports.${report_type}.def, as: 'rdef'}`}>
            {/* These two reports are meant to be percentage change */}
            {title !== 2 ? title !== 8 ? <tr data-bind="if: title" className="subtitle"><th data-bind="text: title"></th></tr> : <tr data-bind="if: percentageTitle" className="subtitle"><th data-bind="text: percentageTitle"></th></tr> : <tr data-bind="if: percentageTitle" className="subtitle"><th data-bind="text: percentageTitle"></th></tr>}
            <ReactComment text="ko foreach: {data: rdef.reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <ReactComment text="ko foreach: $root.regions" />
                <ReactComment text={`ko if: ko.isObservable($root.${table}[rdef.leg][$data][sector])`} />
                  <td data-bind={`numericText: $root.${table}[rdef.leg][$data][sector], precision: $root.empPrec(${precision}, rdef.leg, '${table}')`}></td>
                <ReactComment text="/ko" />
              <ReactComment text="/ko" />
            </tr>
            <ReactComment text="/ko" />
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OutputTable
